import type { CSSProperties } from 'react';

/** Matches Dashkit `.btn-rounded-circle.btn-sm` width; height set explicitly (theme omits height, icons look off-center). */
export const BTN_SM_ROUNDED_CIRCLE_BOX = 'calc(1.75em + .25rem + 2px)';

export const roundSmCircleIconButtonStyle: CSSProperties = {
  width: BTN_SM_ROUNDED_CIRCLE_BOX,
  height: BTN_SM_ROUNDED_CIRCLE_BOX,
  padding: 0,
  boxSizing: 'border-box',
};
